// extracted by mini-css-extract-plugin
export var description = "how-to-help-services-module--description--db7da";
export var heading = "how-to-help-services-module--heading--e137a";
export var icon = "how-to-help-services-module--icon--e1ef9";
export var mainBox = "how-to-help-services-module--mainBox--d7e97";
export var textBox = "how-to-help-services-module--textBox--76066";